angular.module('wbDirectives').directive('wbValidation', function() {
  return {
    require: '?^form',
    restrict: 'E',
    transclude: true,
    replace: true,
    template: `
      <div class="errors" ng-show="form[name].$touched || form.$submitted" ng-messages="form[name].$error" role="alert">
        <div class="error" ng-message="required">required</div>
        <div class="error" ng-message="min">
          <span>The minimum is</span>
          <var>{{ min | _currency }}</var>
        </div>

        <div class="error" ng-message="max">
          <span>The maximum is</span>
          <var>{{ max | _currency }}</var>
        </div>

        <div class="error" ng-message="minlength">
          <span ng-if="minlength && maxlength && minlength !== maxlength">{{ minlength }} to {{ maxlength }} digits without spaces or symbols</span>
          <span ng-if="minlength && !maxlength">Must be {{ minlength }} digits including zeros</span>
        </div>
      </div>`
    ,
    scope: true,
    link: function($scope, $el, $attrs, form, transclude) {
      $scope.digitString = function(digits) {
        return (digits === 1) && "1 digit" || (digits + " digits");
      };
      if (form == null) {
        return;
      }
      $scope.form = form;
      $attrs.$observe('for', function(name) {
        $scope.name = name;
        if (form) {
          return $scope.input = form[name];
        }
      });
      $attrs.$observe('min', function(minimum) {
        return $scope.min = +minimum;
      });
      $attrs.$observe('max', function(maximum) {
        return $scope.max = +maximum;
      });
      $attrs.$observe('minlength', function(minimum) {
        return $scope.minlength = +minimum;
      });
      $attrs.$observe('maxlength', function(maximum) {
        return $scope.maxlength = +maximum;
      });
      return transclude($scope, function(content) {
        return $el.append(content);
      });
    }
  };
});
